<template>
  <div class="err">
    <div id="container">
      <div id="header">
        <img src="../assets/images/404/Errinfo.gif" />
      </div>
      <div id="main"></div>
    </div>
    <div id="footer">
      <img src="../assets/images/404/Errlogo.gif" />
    </div>
  </div>
</template>
<script>
export default {
  name: "404Page",
};
</script>
<style scoped>
#container {
  /* height: calc(100vh - 72px); */
  height: 100vh;
  box-sizing: border-box;
  background: url("../assets/images/404/Erricon.gif") no-repeat center;
}

#header {
  padding: 10px;

  background-color: #376ed1;
}

#main {
  margin: 0px auto;
  height: 300px;
  padding-bottom: 80px;
}

#footer {
  height: 80px;
  margin-top: -80px;
  text-align: center;
  width: 100%;
  text-align: center;
}
</style>
